<template lang="pug">
.w-100.mh-100.h-100
  dx-data-grid(ref="grid"
  :data-source='reportSummary'
  :selection="{ mode: 'single' }"
  :show-borders='true'
  :style="{ height: localHeight, width: localWidth }"
  :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
  :row-alternation-enabled="true"
  :allow-column-reordering="true"
  :allow-column-dragging="false"
  @content-ready="onContentReady")
    dx-scrolling(mode='virtual', :useNative="false")
    dx-sorting(mode="multiple")
    dx-load-panel(:enabled="true")
    dx-header-filter(:visible="true")
    dx-grouping(:auto-expand-all="false", expand-mode="rowClick")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';

export default {
  name: 'Debug',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowIndex',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Type',
        caption: 'Тип интервала',
        groupIndex: 1,
        sortOrder: 'desc',
        customizeText: (params) => {
          switch (params.value) {
            case 'Segment': return 'Сегменты, сформированные детектором поездок по сообщениям объекта';
            case 'FilterInterval': return 'Перечень отфильтрованных интервалов';
            default: return 'Перечень интервалов, сформированный на основании сегментов';
          }
        },
      }, {
        dataField: 'MileageKm',
        caption: 'Пробег, км',
        width: 90,
      }, {
        dataField: 'CityMileageKm',
        caption: 'Городской пробег, км',
        width: 90,
      }, {
        dataField: 'CountryMileageKm',
        caption: 'Загородный пробег, км',
        width: 90,
      }, {
        dataField: 'FromBeginToEndMileageKm',
        caption: 'Пробег от начала до конца, км',
        width: 90,
      }, {
        dataField: 'PointsCount',
        caption: 'Кол-во точек',
        alignment: 'center',
        width: 75,
      }, {
        dataField: 'EventType',
        caption: 'Тип',
        alignment: 'center',
        width: 120,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'End',
        caption: 'Конец',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'Duration',
        caption: 'Длительность',
        alignment: 'center',
        minWidth: 90,
      }],
      reportSummary: [],
    };
  },
  watch: {
    reportData (value) {
      this.convertData(this.reportData);
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    this.convertData(this.reportData);
  },
  methods: {
    convertData (data) {
      if (this.reportData.IsSummary) {
        const rows = [];
        data.Data.Data.forEach((items) => {
          items.Rows.forEach((_row, i) => {
            const row = _row;
            row.ObjectName = items.ObjectName;
            rows.push(row);
          });
        });
        this.reportSummary = rows;
      } else {
        this.reportSummary = data.Data.Data.Rows;
      }
    },
  },
};
</script>
